<div class="py-4 container-fluid subject-management-page">
  <h4 class="mb-4 subject-management-title">การจัดการรายวิชา</h4>

  <div class="subject-management-page-tab-row">
    <div class="segmented-tabs subject-management-tabs" role="tablist" aria-label="เมนูการจัดการรายวิชา">
<button role="tab"
        type="button"
        class="segmented-tab subject-management-tab"
        [class.active]="selectedPageTab === 'subjects'"
        [attr.aria-selected]="selectedPageTab === 'subjects'"
        (click)="onPageTabChange('subjects')"
      >
        จัดการรายวิชา
      </button>
<button role="tab"
        type="button"
        class="segmented-tab subject-management-tab"
        [class.active]="selectedPageTab === 'new_course_notes'"
        [attr.aria-selected]="selectedPageTab === 'new_course_notes'"
        (click)="onPageTabChange('new_course_notes')"
      >
        ขอเพิ่ม/แก้ไขรายวิชาใหม่
      </button>
    </div>
  </div>

  <div class="subject-management-card">
    <div class="subject-management-card-body">
      <div class="subject-management-toolbar" [formGroup]="form">
        <div class="subject-management-filters">
          <div class="subject-management-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="true"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="subject-management-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="true"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>
          @if (selectedPageTab === 'subjects') {
          <div class="subject-management-filter">
            <app-select
              label="ประเภทรายวิชา"
              formControlName="subjectType"
              [options]="subjectTypeOptions"
              bindLabel="label"
              bindValue="id"
              [searchable]="false"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>
          }

          <div class="subject-management-search-filter">
            <app-filter-search-input
              [label]="selectedPageTab === 'subjects' ? 'รหัสวิชา, ชื่อรายวิชา' : 'ชื่ออาจารย์, รายละเอียดคำขอ'"
              formControlName="keyword"
              inputClass="subject-management-search-input"
              classes="mb-0"
              [ariaLabel]="selectedPageTab === 'subjects' ? 'ค้นหารายวิชา' : 'ค้นหาคำขอเพิ่มรายวิชาใหม่'"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

          @if (selectedPageTab === 'subjects') {
          <div class="subject-management-filter">
            <app-select
              label="หลักสูตร"
              formControlName="curriculumType"
              [options]="curriculumOptions"
              bindLabel="label"
              bindValue="id"
              [searchable]="true"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>
          }
        </div>
      </div>

      @if (selectedPageTab === 'subjects') {
        <div class="subject-status-actions subject-status-actions-with-scrollbar">
          <div class="subject-status-tabs-scroll-region">
            <div
              id="subject-status-tabs-viewport"
              class="subject-status-tabs-viewport"
            >
              <div class="segmented-tabs segmented-tabs--sm subject-status-tabs" role="tablist" aria-label="ตัวกรองสถานะรายวิชา">
<button [attr.aria-selected]="selectedTab === 'all'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'all'"
                (click)="onTabChange('all')"
              >
                รายการทั้งหมด
                </button>
<button [attr.aria-selected]="selectedTab === 'special_revision_requested'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'special_revision_requested'"
                (click)="onTabChange('special_revision_requested')"
              >
                ส่งกลับแก้ไขพิเศษ
                </button>
<button [attr.aria-selected]="selectedTab === 'revision_requested'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'revision_requested'"
                (click)="onTabChange('revision_requested')"
              >
                ส่งกลับแก้ไข
                </button>
<button [attr.aria-selected]="selectedTab === 'ready_for_teacher'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'ready_for_teacher'"
                (click)="onTabChange('ready_for_teacher')"
              >
                รอดำเนินการ
                </button>
<button [attr.aria-selected]="selectedTab === 'teacher_confirmed'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'teacher_confirmed'"
                (click)="onTabChange('teacher_confirmed')"
              >
                รอพิจารณารับรอง
                </button>
<button [attr.aria-selected]="selectedTab === 'imported_pending_fix'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'imported_pending_fix'"
                (click)="onTabChange('imported_pending_fix')"
              >
                แบบร่าง
                </button>
<button [attr.aria-selected]="selectedTab === 'approved'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="selectedTab === 'approved'"
                (click)="onTabChange('approved')"
              >
                รับรองแล้ว
                </button>
              </div>
            </div>
          </div>

          @if (!isSubjectManagementViewOnly) {
            <button
              type="button"
              class="btn subject-management-add-button"
              [disabled]="!isSelectedTermSynced"
              (click)="onAddSubject()"
            >
              <img src="assets/media/icons/svg/add-item.svg" class="subject-management-toolbar-icon" alt="" aria-hidden="true" />
              <span>เพิ่มรายวิชา</span>
            </button>
          }
        </div>
      } @else {
        <div class="subject-status-actions">
          <div class="subject-status-tabs-viewport subject-status-tabs-viewport-compact">
            <div
              class="segmented-tabs segmented-tabs--sm subject-status-tabs subject-status-tabs-new-course-requests"
              role="tablist"
              aria-label="ตัวกรองสถานะคำขอเพิ่มรายวิชาใหม่"
            >
<button [attr.aria-selected]="activeNoteStatusTab === 'all'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="activeNoteStatusTab === 'all'"
                (click)="onActiveNoteStatusTabChange('all')"
              >
                รายการทั้งหมด
              </button>
<button [attr.aria-selected]="activeNoteStatusTab === 'pending'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="activeNoteStatusTab === 'pending'"
                (click)="onActiveNoteStatusTabChange('pending')"
              >
                รอดำเนินการ
              </button>
<button [attr.aria-selected]="activeNoteStatusTab === 'completed'" role="tab"
                type="button"
                class="segmented-tab subject-status-tab"
                [class.active]="activeNoteStatusTab === 'completed'"
                (click)="onActiveNoteStatusTabChange('completed')"
              >
                สำเร็จ
              </button>
            </div>
          </div>
        </div>
      }

      <ng-template #manualStatusTemplate let-row="row">
        <span class="subject-management-manual-status-cell">
          @if (row.isSynced === false) {
          <img
            src="assets/media/icons/svg/user-create.svg"
            class="subject-management-manual-status-icon"
            alt=""
            aria-hidden="true"
          />
          }
        </span>
      </ng-template>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span
          class="subject-management-status-badge"
          [class.subject-management-status-badge-progress]="row.status === 'in_progress'"
          [class.subject-management-status-badge-pending]="row.status === 'pending'"
          [class.subject-management-status-badge-pending-approval]="row.status === 'pending_approval'"
          [class.subject-management-status-badge-special-sent-back]="row.status === 'special_sent_back'"
          [class.subject-management-status-badge-sent-back]="row.status === 'sent_back'"
          [class.subject-management-status-badge-completed]="row.status === 'completed'"
          [class.subject-management-status-badge-draft]="row.status === 'draft'"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="subject-management-actions">
          <button
            type="button"
            class="btn subject-management-action-button"
            [disabled]="!isSelectedTermSynced"
            [attr.aria-label]="isSubjectManagementViewOnly ? 'ดูรายละเอียดรายวิชา' : 'แก้ไขรายวิชา'"
            (click)="onEditSubject(row)"
          >
            <img
              [src]="isSubjectManagementViewOnly ? 'assets/media/icons/svg/eye.svg' : 'assets/media/icons/svg/pencxil.svg'"
              class="subject-management-action-icon"
              [class.datatable-view-action-icon]="isSubjectManagementViewOnly"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <ng-template #activeNoteStatusTemplate let-row="row">
        <span
          class="subject-management-status-badge"
          [class.subject-management-status-badge-pending]="row.status === 'pending'"
          [class.subject-management-status-badge-completed]="row.status === 'completed'"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #activeNoteActionTemplate let-row="row">
        <div class="subject-management-actions">
          <button
            type="button"
            class="btn subject-management-action-button"
            aria-label="ดูรายละเอียดคำขอเพิ่มรายวิชาใหม่"
            (click)="onOpenActiveNote(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="subject-management-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      @if (selectedPageTab === 'subjects') {
      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [isLoading]="tableLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="subject management pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
      } @else {
      <app-datatable
        [datasource]="activeNoteDatasource()"
        [columns]="activeNoteColumns"
        [isLoading]="activeNoteLoading()"
        [limit]="activeNoteDatasource().limit"
        [showOrder]="false"
        [externalSorting]="false"
      ></app-datatable>

      <app-table-pagination
        [page]="activeNoteDatasource().page"
        [limit]="activeNoteDatasource().limit"
        [total]="activeNoteDatasource().total"
        [totalPage]="activeNoteDatasource().total_page"
        [offset]="activeNoteDatasource().offset"
        [dataLength]="activeNoteDatasource().data.length"
        [isLoading]="activeNoteLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="special new-course request pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
      }
    </div>
  </div>
</div>

<div
  class="modal fade"
  [id]="activeNoteModalId"
  tabindex="-1"
  aria-labelledby="subjectManagementActiveNoteModalTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="subject-management-note-modal-title">
          <h5 class="modal-title" id="subjectManagementActiveNoteModalTitle">รายละเอียดคำขอเพิ่มรายวิชาใหม่</h5>
          @if (selectedActiveNote(); as note) {
            <span
              class="subject-management-status-badge"
              [class.subject-management-status-badge-pending]="note.status === 'pending'"
              [class.subject-management-status-badge-completed]="note.status === 'completed'"
            >{{ activeNoteStatusLabel(note.status, note.status_label) }}</span>
          }
        </div>
        <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseActiveNote()"></button>
      </div>
      <div class="modal-body">
        @if (selectedActiveNote(); as note) {
        <section class="subject-management-note-section">
          <h6>ข้อมูลผู้ส่งคำขอ</h6>
          <div class="subject-management-note-detail-grid">
            <div class="subject-management-note-detail-item subject-management-note-detail-item-full">
              <strong>ชื่อ - นามสกุลอาจารย์ :</strong>
              <span>{{ note.requested_by?.teacher_display_name || note.requested_by?.full_name || '-' }}</span>
            </div>
            <div class="subject-management-note-detail-item">
              <strong>ภาคการศึกษา :</strong>
              <span>{{ note.semester || note.academic_term?.name || '-' }}</span>
            </div>
            <div class="subject-management-note-detail-item">
              <strong>ปีการศึกษา :</strong>
              <span>{{ displayYear(note.academic_year || note.academic_term?.year) }}</span>
            </div>
            <div class="subject-management-note-detail-item subject-management-note-detail-item-full">
              <strong>วันที่ส่งคำขอ :</strong>
              <span>{{ formatDateTime(note.requested_at) }}</span>
            </div>
          </div>
        </section>

        <section class="subject-management-note-section">
          <h6>รายละเอียดคำขอเพิ่มรายวิชา</h6>
          <p class="subject-management-note-detail-text">{{ note.new_course_request_note || note.note || '-' }}</p>
        </section>
        }
      </div>
      <div class="modal-footer subject-management-note-modal-footer">
        <button type="button" class="btn btn-light" (click)="onCloseActiveNote()">ปิด</button>
        @if (hasActiveNoteSchedule()) {
          <button
            type="button"
            class="btn btn-primary subject-management-add-button subject-management-note-schedule-button"
            (click)="onOpenActiveNoteSchedule()"
          >
            ไปยังตารางสอน
          </button>
        }
      </div>
    </div>
  </div>
</div>
